<nav class="toolbar">
  <div class="toolbar-left">
    <span class="page-title">Panel de Control</span>
  </div>

  <div class="toolbar-right">
    @if (user()) {
      <div class="user-info">
        <span class="user-name">{{ user()!.email }}</span>
      </div>
      <button class="logout-btn" (click)="logout()">
        <i class="bi bi-box-arrow-right"></i>
        <span class="label">Salir</span>
      </button>
    }
  </div>
</nav>
